/** */
import React from 'react';
import cx from 'classnames';
import { Route, Routes, useNavigate } from 'react-router-dom';

/** */
import LoginForm from './login/login';

/** */
import styles from './guest.module.css';
import { SiteIcon } from 'assets/icons';

const GuestArea = () => {
  const navigateTo = useNavigate();
  return (
    <div className={styles.wrapper}>
      <div className={cx(styles.header, 'flex-row-center')}>
        <SiteIcon width={48} height={24} onClick={() => navigateTo('/')} />
        <span className={styles.siteName} onClick={() => navigateTo('/')}>
          {' '}
          Go-Mailer{' '}
        </span>
      </div>
      <div className={styles.formWrapper}>
        <Routes>
          <Route path="/" element={<LoginForm />} />
        </Routes>
      </div>
    </div>
  );
};

export default GuestArea;
